import React from "react";
import { render } from "react-dom";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";

import App from "./containers/app/App.jsx";

import store from "./state/store/Store.js";
import rootSaga from "./state/sagas/sagas.js";

import { createAction } from "./state/actions/actionUtils.js";

import { STARTUP } from "./state/actions/actionConstants.js";

import "core-js/stable";
import "regenerator-runtime/runtime";
import "styles/index.less";
import "styles/supporting/index.less";

// start all our sagas
store.runSaga(rootSaga);

// load config, locale, endpoints and startup Pusher
store.dispatch(
  createAction(STARTUP.GET, {
    endpoint: "/",
    locale: "en-en",
    pagination: false
  })
);

// let's do this!
render(
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>,
  document.getElementById("app-container")
);
